import React from "react";
import "./Thanyou.css";
import Footer from "../components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCoffee,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

import herotext from "../assets/images/banner-text.png";
import herotextMobile from "../assets/images/banner-text-mobile.png";
import BannerImg1 from "../assets/images/banner-img1.png";
import BannerImg2 from "../assets/images/banner-img2.png";
import Navbar from "../components/Navbar";

const Thankyou = () => {
  return (
    <>
      {/* Inline CSS to hide popup on this page */}
      <style>
        {`
          .popup.active { 
            display: none !important; 
          }
          
          /* Additional selectors for different popup classes */
          .MuiSnackbar-root {
            display: none !important;
          }
          
          .load-popup-main {
            display: none !important;
          }
          
          /* Hide any popup with these common classes */
          .popup,
          .snackbar,
          .notification-popup {
            display: none !important;
          }
        `}
      </style>
      
      <div className="thanyou-page">
        <div className="herosectioncontainer">
          <Navbar />
          <div className="hero">
            <div className="hero-main-content">
              <h2>Thank you for choosing<br></br>RoboAI Program.</h2>
              <p>*we will get back to you shortly.</p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Thankyou;